import { useRouter } from 'next/router'
import { propOr } from 'ramda'
import { useMemo } from 'react'

import Button, { ButtonVariant } from '@/components/button'
import Link from '@/components/link'

import useProgramRegistrations from '../../../dashboard/events/stores/use-program-registrations'
import { getActiveRegistrations } from '../../utils/active-registrations'
import useProgram from '../stores/use-program'
import RegisteredSessions from './registered-sessions'
// import Slider from './slider'

const programSelector = propOr({}, 'program')
const registrationsSelector = propOr([], 'registrations')

const Details = () => {
  const {
    query: { handle },
  } = useRouter()
  const program = useProgram(programSelector)

  const registrations = useProgramRegistrations(registrationsSelector)

  const activeRegistrations = useMemo(
    () => getActiveRegistrations(program.id, registrations),
    [program.id, registrations],
  )

  return (
    <div className='mx-auto mt-14'>
      <div className='flex flex-col-reverse'>
        <div>
          <h1 className='custom-font-37 mb-6 font-bold uppercase text-theme-blue-gray'>
            {program.title}
          </h1>

          <h2 id='information-heading' className='sr-only'>
            Product information
          </h2>
          {/* <p className='custom-font-30'>
            Version {program.version} (Updated{' '}
            <time dateTime={program.version}>{program.version}</time>)
          </p> */}
        </div>
      </div>

      <p className='custom-font-24'>{program.intro}</p>
      {/* <Slider /> */}
      <RegisteredSessions />

      {!activeRegistrations?.length && (
        <div className='mt-5 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2'>
          <Link
            href={`/program/${handle}/register`}
            className='max-w-[fit-content] hover:no-underline'
          >
            {/* <button
              type='button'
              className='flex w-fit items-center justify-center rounded-2xl border border-transparent bg-theme-coral py-2 px-4 text-base text-lg font-medium text-gray-900 hover:bg-theme-coral focus:outline-none focus:ring-2 focus:ring-theme-coral focus:ring-offset-2'
            >
              <span className='translate-y-0.5'>SIGN UP {program.price}</span>
            </button> */}
            <Button
              variant={ButtonVariant.Primary}
              bg='bg-[#F59175]'
              tailFill='#F59175'
              className='cm-bg !px-3 !py-2 !text-base text-white'
              tailClassName='right-[unset] left-0 scale-x-[-1] -translate-x-[50%] translate-y-[41%] h-2'
            >
              <span className='translate-y-0.5'>SIGN UP {program.price}</span>
            </Button>
          </Link>
        </div>
      )}
    </div>
  )
}

export default Details
